import { render, staticRenderFns } from "./exhibitionHall.vue?vue&type=template&id=68ccc686&scoped=true&"
import script from "./exhibitionHall.vue?vue&type=script&lang=js&"
export * from "./exhibitionHall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ccc686",
  null
  
)

export default component.exports